import { render } from "./SongDetailsTab.vue?vue&type=template&id=0fffc33c"
import script from "./SongDetailsTab.vue?vue&type=script&lang=js"
export * from "./SongDetailsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__